import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

/**
 * Reusable search input with magnifying glass icon.
 * @param {{ value: string, onChange: (value: string) => void, placeholder?: string, className?: string }} props
 */
export default function SearchInput({ value, onChange, placeholder = 'Пребарувај...', className = '' }) {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
}
